import * as actionTypes from "../actionTypes";

const initialState = {
  languageData: [],
};

const languageReducer = (state = initialState, actions) => {
  const { payload, type } = actions;

  switch (type) {
    case actionTypes.SET_LANGUAGE:
      return { ...state, languageData: payload };

    default:
      return state;
  }
};

export default languageReducer;